import React, { useEffect } from "react";
import { app, pages } from "@microsoft/teams-js";
import { APP_BASE_URL } from "../utility/constants";

const ConfigPage = () => {

   useEffect(() => {
  // app.initialize()
  //   .then(() => {
  //       console.log("Teams SDK Initialized (Config)");

  //       // Get context first to ensure proper initialization
  //       return app.getContext();
  //   })
  //   .then((context) => {
  //       console.log("Context obtained:", context);

  //       const baseUrl = APP_BASE_URL;
  //       const tabContentUrl = `${baseUrl}/tab`;

  //       // Register save handler
  //       pages.config.registerOnSaveHandler(async (saveEvent) => {
  //           try {
  //               console.log("Save event triggered");

  //               // Double-check context
  //               const currentContext = await app.getContext();
  //               console.log("Save context:", currentContext);

  //               // Set config with minimal options first
  //               const config = {
  //                   suggestedDisplayName: "Givent",
  //                   entityId: "givent",
  //                   contentUrl: tabContentUrl,
  //                   websiteUrl: tabContentUrl
  //               };

  //               console.log("Setting config:", config);
  //               pages.config.setConfig(config);

  //               // Add small delay to ensure config is processed
  //               setTimeout(() => {
  //                   console.log("Notifying success");
  //                   saveEvent.notifySuccess();
  //               }, 100);

  //           } catch (error) {
  //               console.error("Error in save handler:", error);
  //               if (saveEvent.notifyFailure) {
  //                   saveEvent.notifyFailure(error.message);
  //               }
  //           }
  //       });

  //       // Enable save button after handler is registered
  //       console.log("Setting validity state to true");
  //       pages.config.setValidityState(true);
  //   })
  //   .catch((error) => {
  //       console.error("Initialization failed:", error);
  //       // Still enable save button to see what happens
  //       pages.config.setValidityState(true);
  //   });
app.initialize().then(() => {
  console.log("Teams SDK Initialized");

  // Initially disable Save button
  pages.config.setValidityState(false);

  // Enable Save button for team/groupChat context
  app.getContext().then((context) => {
    if (context.channel || context.chat?.id) {
      pages.config.setValidityState(true);

      pages.config.registerOnSaveHandler((saveEvent) => {
        pages.config.setConfig({
          entityId: `givent-${Date.now()}`,
          contentUrl: `${APP_BASE_URL}`,
          websiteUrl: `${APP_BASE_URL}`,
          suggestedDisplayName: "Givent"
        })
        .then(() => saveEvent.notifySuccess())
        .catch(err => saveEvent.notifyFailure("Failed to save config"));
      });
    } else {
      console.warn("Not in a team or group chat; Save disabled.");
    }
  });
}).catch(err => console.error("Teams SDK init failed:", err));




}, []);



  return (
    <div className="givent-container">
      <div className="givent-header">
        <h1 className="givent-title">Welcome to Givent</h1>
      </div>
      <p className="givent-description">
        Givent helps nonprofits raise donations directly within Microsoft Teams.
        Use this tab to showcase your fundraising campaigns, show donation
        stream, and engage your team in giving.
      </p>
      <p className="givent-instruction">
        Please complete the setup below to configure this tab for your campaign
        or organization.
        <br />
        Click the <strong>Save</strong> button to complete the configuration.
      </p>
    </div>
  );
};

export default ConfigPage;
